<template>
  <el-card
    class="box-card"
    v-loading.fullscreen.lock="loading"
    element-loading-text="努力上传中"
  >
    <div class="card-contetn">
      <el-form
        style="width: 900px; margin: 0 auto"
        :model="dataForm"
        label-position="right"
        label-width="100px"
        :rules="rules"
        ref="dataForm"
        class="demo-ruleForm"
        v-if="active == 0"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="运营商名称" prop="operatorName">
              <el-input
                v-model="dataForm.operatorName"
                placeholder="请输入姓名"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="责任人" prop="principal">
              <el-input
                v-model="dataForm.principal"
                placeholder="请输入责任人"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input
                v-model="dataForm.mobile"
                placeholder="请输入手机号"
                autocomplete="off"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录账号" prop="username">
              <el-input
                v-model="dataForm.username"
                placeholder="请输入账号"
                autocomplete="off"
                maxlength="18"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录密码" prop="password">
              <el-input
                type="password"
                v-model="dataForm.password"
                placeholder="请输入登录密码"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确认密码" prop="newPassword">
              <el-input
                type="password"
                v-model="dataForm.newPassword"
                placeholder="请输入确认密码"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="返点值" prop="rebate">
              <el-input
                type="number"
                v-model.trim="dataForm.rebate"
                placeholder="请输入返点值"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账期" prop="accountPeriod">
              <el-input
                type="number"
                v-model.trim="dataForm.accountPeriod"
                placeholder="请输入账期"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div v-if="active == 1 && info.tanantState == 1" class="submitCheck">
        <i class="el-icon-success icon-style"></i>
        <h3>资料提交成功</h3>
        <p>请等待审核通知！</p>
      </div>
      <div v-else-if="active == 2 && info.tanantState == 3" class="submitCheck">
        <i class="el-icon-error icon-style" style="color: red"></i>
        <h3>审核失败，请修改资料重新提交！</h3>
        <p>{{ info.tanantRemark }}</p>
      </div>

      <div class="stepBtn" v-if="active == 0">
        <el-button @click="prevStep" type="primary">保存</el-button>
        <!-- <el-button type="primary" @click="nextStep">下一步</el-button> -->
      </div>
      <div class="stepBtn check" v-else>
        <el-button @click="backHandle">返回</el-button>
        <el-button
          type="primary"
          @click="seeInfoHandle"
          v-if="info.tanantState == 3"
          >{{ "修改资料" }}</el-button
        >
        <el-button
          type="primary"
          @click="querySee"
          v-if="info.tanantState == 1"
          >{{ "查看资料" }}</el-button
        >
      </div>
    </div>
  </el-card>
</template>
<script>
import reg from "@/utils/regular.js";
// import debounce from "lodash/debounce";
// import ImgUpload from "@/components/img-upload";
// import { delete } from 'vue/types/umd';
export default {
  name: "enterpriseBusiness",
  components: {
    // ImgUpload,
  },
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      }
      if (!reg.phone.test(value)) {
        callback(new Error("请输入正确的手机号"));
      }
      callback();
    };

    let checkuser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户"));
      }
      if (!reg.userreg.test(value)) {
        callback(new Error("账号为6-18位任意组合"));
      }
      callback();
    };

    let checkPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户密码"));
      }
      if (!reg.pwdreg.test(value)) {
        callback(new Error("密码为6-18位数字或字母组合"));
      }
      callback();
    };

    let checkZheng = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入数字"));
      }
      if (!reg.isZheng.test(value)) {
        callback(new Error("请输入整数"));
      }
      callback();
    };

    let checkXiao = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入数字"));
      }

      if (!reg.isPercent.test(value)) {
        callback(new Error("请输入0-1之间的小数,最多三位小数"));
      }
      callback();
    };

    var validateComfirmPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("确认密码不能为空"));
      } else if (value !== this.dataForm.password) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };

    return {
      password2: "",
      actions: "",
      loading1: false,
      loading2: false,
      approveId: "",
      infoId: "",
      tenantInformationId: "",
      info: {},

      loading: false,
      rules: {
        username: [{ required: true, validator: checkuser, trigger: "blur" }],
        password: [{ required: true, validator: checkPwd, trigger: "blur" }],
        newPassword: [
          {
            required: true,
            validator: validateComfirmPassword,
            trigger: "blur",
          },
        ],
        mobile: [{ required: true, validator: checkPhone, trigger: "blur" }],
        principal: [
          { required: true, message: "请输入负责人", trigger: "blur" },
        ],
        rebate: [{ required: true, validator: checkXiao, trigger: "blur" }],
        accountPeriod: [
          { required: true, validator: checkZheng, trigger: "blur" },
        ],
        operatorName: [
          { required: true, message: "运营商不能为空", trigger: "blur" },
        ],
      },

      dataForm: {
        tenantCode: 7777777,
        operatorName: "",
        principal: "",
        mobile: "",
        username: "",
        password: "",
        rebate: "",
        accountPeriod: "",
        id: "",
        operatorId: "",
        newPassword: "",
      },

      isEdit: true,
      active: 0,
      imageUrl1: "",
      imageUrl2: "",
      imageUrl3: "",
      flag: false,
      flag2: false,
      provinceList: [],
      cityList: [],
      districtList: [],
      isClear: true,
    };
  },
  watch: {
    isEdit() {
      this.$refs.dataForm.clearValidate();
    },
    $route(to) {
      this.approveId = to.query.approveId;
      if (this.active == 0)
        this.getBaseInfo(
          sessionStorage.getItem("tenantInformationId") || this.approveId
        );
    },
  },
  // activated() {
  //   this.getInfo();
  // },
  created() {
    if (this.$route.query.record) {
      this.active = this.$route.query.record * 1;
      this.approveId = this.$route.query.approveId;
    }
    if (this.active >= 1) {
      this.getBaseInfo(sessionStorage.getItem("tenantInformationId")||this.approveId);
    }
  },
  methods: {
    //审批
    isCheck() {
      this.$request
        .post("/approver-api/api/web/approvetenantinformation/check")
        .then((res) => {
          console.log(res);
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.info = res.data;
          if (this.info.tanantState == 3) {
            this.active = 2;
          } else if (this.info.tanantState == 2) {
            this.active = 3;
          } else if (this.info.tanantState == 1) {
            this.active = 1;
          }
          if (res.data.approveRecordList.length > 0) {
            sessionStorage.setItem(
              "tenantInformationId",
              res.data.approveRecordList[0].approveId
            );
            if (res.data.approveRecordList[1]) {
              sessionStorage.setItem(
                "enterpriseAccountId",
                res.data.approveRecordList[1].approveId
              );
            }
          }
        });
    },
    prevStep() {
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          console.log(valid)
        } else {
          if (this.flag) {
            return;
          }
          this.flag = true;
          this.$request
            .post(
              "/approver-api/api/web/approvetenantinformation/operatorRegister",
              {
                ...this.dataForm,
                tenantInformationId: this.tenantInformationId
                  ? this.tenantInformationId
                  : this.approveId,
                  platformId:this.$route.query.platformId
              }
            )
            .then((res) => {
              this.flag = false;
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$router.push({
                name: "OperatorRegistration",
                query: { record: 2 ,platformId:this.$route.query.platformId},
              });
              this.active = 2;
              this.isCheck();
            })
            .catch((e) => {
              console.log(e);
              this.flag = false;
            });
        }
      });
    },

    //得到基本信息
    getBaseInfo(tenantInformationId) {
      this.$request
        .post(
          `/approver-api/api/web/approvetenantinformation/operatorRegisterInfo`,
          {
            tenantInformationId,
            platformId:this.$route.query.platformId

          }
        )
        .then((res) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
            tenantCode: 7777777,
          };
          this.isCheck();
        });
    },

    getImg1(val) {
      this.loading = false;
      this.dataForm2.idCardPicFrontList = [];
      this.dataForm2.idCardPicFrontList.push(val);
    },
    getLoading(data) {
      this.loading = data;
    },
    getImg2(val) {
      console.log(val);
      this.loading = false;
      this.dataForm2.idCardPicBackList = [];
      this.dataForm2.idCardPicBackList.push(val);
    },
    getImg3(val) {
      console.log(val);
      this.loading = false;
      this.dataForm2.businessLicensePicList = [];
      this.dataForm2.businessLicensePicList.push(val);
    },
    seeInfoHandle() {
      if (this.info.tanantState == 3) {
        this.active = 0;
      }
    },
    querySee() {
      setTimeout(() => {
        this.$router.push({
          name: "OperatorInfo",
          query: {
            id: sessionStorage.getItem("tenantInformationId") || this.approveId,platformId:this.$route.query.platformId
          },
        });
      }, 200);
    },
    backHandle() {
      this.$router.push({ name: "operatoRegister" });
    },
  },
};
</script>
<style lang="less" scoped>
.el-form {
  h3 {
    padding-left: 50px;
    box-sizing: border-box;
    margin-top: 20px;
  }
}

.el-form-item {
  /deep/ .el-form-item__content {
    display: flex;
  }
}

.el-card {
  .el-steps {
    padding: 20px;
  }
  .stepBtn {
    text-align: center;
  }

  .text {
    position: absolute;
    font-size: 12px;
    color: #ccc;
    top: 10px;
    right: -90px;
  }
  .otherText {
    top: 20px;
    left: -100px;
  }
  .submitCheck {
    text-align: center;
    margin-top: 50px;
    .icon-style {
      color: green;
      display: block;
      font-size: 100px;
      margin: 0 auto;
    }
    p {
      margin-bottom: 70px;
    }
  }
  .card-contetn {
    min-height: 100vh;
  }
}

.avatar-uploader {
  border: 1px dashed #ccc;
  height: 60px;
  width: 80px;
  text-align: center;
  /deep/ .el-upload--text {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>